import { LoaderFunction } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";

export const hospitalListLoader: LoaderFunction = async () => {

    const result = await axiosApi.get("/api/hospitals/");

    return result.data
}